import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = {
  key: 0,
  class: "icon placeholder-icon"
}

import {IField} from '~/cabinet/vue/interface/form/elements/Interfaces';
import SvgIcon from "~/chat/vue/misc/SvgIcon.vue";


const __default__ = {
    name: "InputWrapperWithIcon"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    field: {},
    iconAllowed: { type: Boolean, default: true },
    required: { type: Boolean },
    scrollbarWidth: {}
  },
  setup(__props: any) {

let props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$slots.icon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "icon")
        ]))
      : (_ctx.iconAllowed)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.field.icon)
              ? (_openBlock(), _createBlock(SvgIcon, {
                  key: 0,
                  class: "icon",
                  "icon-name": _ctx.field.icon,
                  "icon-style": _ctx.field.iconStyle
                }, null, 8, ["icon-name", "icon-style"]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default"),
    (_ctx.required)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "required text-red",
          style: _normalizeStyle(_ctx.scrollbarWidth ? `transform: translateX(-${_ctx.scrollbarWidth}px) !important` : null)
        }, null, 4))
      : _createCommentVNode("", true)
  ]))
}
}

})